module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_114-c8a302fd39f719836bc4c28c049b8ace.png";